import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../services/api';

const ARViewer = ({ modelUrl, onClose }) => {
  if (!modelUrl) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.9)', zIndex: 1000,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: 20,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', maxWidth: 600, marginBottom: 16 }}>
        <h3 style={{ color: '#38bdf8' }}>🥽 Realidad Aumentada</h3>
        <button onClick={onClose} style={{
          background: '#ef4444', color: 'white', border: 'none',
          borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontWeight: 600,
        }}>✕ Cerrar</button>
      </div>
      <div style={{ width: '100%', maxWidth: 600, height: 500, borderRadius: 16, overflow: 'hidden' }}>
        <model-viewer
          src={modelUrl}
          alt="Modelo 3D del platillo"
          camera-controls
          auto-rotate
          ar
          ar-modes="webxr scene-viewer quick-look"
          shadow-intensity="1"
          exposure="1"
          style={{ width: '100%', height: '100%', background: '#1e293b' }}
        >
          <button slot="ar-button" style={{
            position: 'absolute', bottom: 20, left: '50%', transform: 'translateX(-50%)',
            background: '#38bdf8', color: '#0f172a', border: 'none',
            borderRadius: 10, padding: '12px 24px', fontWeight: 700,
            cursor: 'pointer', fontSize: 14,
          }}>
            📱 Ver en tu espacio (AR)
          </button>
        </model-viewer>
      </div>
      <p style={{ color: '#94a3b8', marginTop: 16, fontSize: 13, textAlign: 'center' }}>
        Toca el botón azul y apunta tu cámara a una superficie plana para ver el plato en AR
      </p>
    </div>
  );
};

const ProductModal = ({ product, onClose }) => {
  const [showAR, setShowAR] = useState(false);

  if (!product) return null;

  return (
    <>
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.8)', zIndex: 500,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 20,
      }} onClick={onClose}>
        <div className="card animate-fade-in" style={{
          maxWidth: 560, width: '100%', maxHeight: '85vh', overflowY: 'auto',
          position: 'relative',
        }} onClick={(e) => e.stopPropagation()}>
          <button onClick={onClose} style={{
            position: 'absolute', top: 16, right: 16,
            background: '#334155', color: '#e2e8f0', border: 'none',
            borderRadius: '50%', width: 32, height: 32,
            cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>✕</button>

          {product.image_url && (
            <img src={product.image_url} alt={product.name} style={{
              width: '100%', height: 220, objectFit: 'cover', borderRadius: 12, marginBottom: 20,
            }} />
          )}

          <h2 style={{ color: '#e2e8f0', marginBottom: 8, fontSize: 24 }}>{product.name}</h2>
          <p style={{ color: '#fbbf24', fontSize: 22, fontWeight: 700, marginBottom: 16 }}>
            ${product.price?.toFixed(2)}
          </p>

          {product.description && (
            <div style={{ marginBottom: 16 }}>
              <h4 style={{ color: '#94a3b8', fontSize: 12, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 }}>Descripción</h4>
              <p style={{ color: '#cbd5e1', fontSize: 14, lineHeight: 1.6 }}>{product.description}</p>
            </div>
          )}

          {product.ingredients && (
            <div style={{ marginBottom: 16 }}>
              <h4 style={{ color: '#94a3b8', fontSize: 12, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 }}>Ingredientes</h4>
              <p style={{ color: '#cbd5e1', fontSize: 14, lineHeight: 1.6 }}>{product.ingredients}</p>
            </div>
          )}

          {product.history && (
            <div style={{
              background: 'rgba(56, 189, 248, 0.05)',
              border: '1px solid rgba(56, 189, 248, 0.2)',
              borderRadius: 10, padding: 16, marginBottom: 16,
            }}>
              <h4 style={{ color: '#38bdf8', fontSize: 12, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 }}>📖 Historia</h4>
              <p style={{ color: '#94a3b8', fontSize: 13, lineHeight: 1.6, fontStyle: 'italic' }}>{product.history}</p>
            </div>
          )}

          <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
            {product.model_3d_url && (
              <button onClick={() => setShowAR(true)} className="btn btn-primary" style={{ flex: 1 }}>
                🥽 Ver en AR
              </button>
            )}
          </div>
        </div>
      </div>
      {showAR && <ARViewer modelUrl={product.model_3d_url} onClose={() => setShowAR(false)} />}
    </>
  );
};

const MenuPage = () => {
  const { branchCode } = useParams();
  const [menu, setMenu] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [activeCategory, setActiveCategory] = useState(null);

  useEffect(() => {
    api.get(`/menu/${branchCode}`)
      .then(res => {
        setMenu(res.data.data);
        if (res.data.data.categories?.length > 0) {
          setActiveCategory(res.data.data.categories[0].id);
        }
      })
      .catch(err => console.error('Error cargando menú:', err))
      .finally(() => setLoading(false));
  }, [branchCode]);

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a' }}>
      <p style={{ color: '#94a3b8' }}>Cargando menú...</p>
    </div>
  );

  if (!menu) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a' }}>
      <p style={{ color: '#ef4444' }}>Menú no encontrado</p>
    </div>
  );

  const activeCat = menu.categories.find(c => c.id === activeCategory);

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a' }}>
      {/* Header */}
      <header style={{
        background: 'linear-gradient(135deg, #1e293b, #0f172a)',
        borderBottom: '1px solid #334155',
        padding: '24px 20px',
        textAlign: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}>
        <h1 style={{ color: '#38bdf8', fontSize: 28, marginBottom: 4 }}>🍽️ {menu.branch.name}</h1>
        <p style={{ color: '#94a3b8', fontSize: 14 }}>Menú Digital Interactivo</p>
      </header>

      {/* Categorías */}
      <div style={{
        display: 'flex',
        gap: 10,
        padding: '16px 20px',
        overflowX: 'auto',
        borderBottom: '1px solid #334155',
        background: '#0f172a',
      }}>
        {menu.categories.map(cat => (
          <button
            key={cat.id}
            onClick={() => setActiveCategory(cat.id)}
            style={{
              padding: '10px 20px',
              borderRadius: 20,
              border: 'none',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 600,
              background: activeCategory === cat.id
                ? 'linear-gradient(135deg, #38bdf8, #0ea5e9)'
                : '#1e293b',
              color: activeCategory === cat.id ? '#0f172a' : '#94a3b8',
              transition: 'all 0.2s',
            }}
          >
            {cat.icon} {cat.name}
          </button>
        ))}
      </div>

      {/* Productos */}
      <div style={{ padding: '20px', maxWidth: 800, margin: '0 auto' }}>
        {activeCat?.products?.length === 0 && (
          <p style={{ color: '#64748b', textAlign: 'center', padding: 40 }}>No hay productos en esta categoría</p>
        )}

        <div style={{ display: 'grid', gap: 16 }}>
          {activeCat?.products?.map(product => (
            <div
              key={product.id}
              onClick={() => setSelectedProduct(product)}
              className="card animate-fade-in"
              style={{
                display: 'flex',
                gap: 16,
                cursor: 'pointer',
                transition: 'transform 0.2s, box-shadow 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{
                width: 100, height: 100, borderRadius: 12,
                background: product.image_url ? `url(${product.image_url}) center/cover` : '#334155',
                flexShrink: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 40,
              }}>
                {!product.image_url && '🍽️'}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
                  <h3 style={{ color: '#e2e8f0', fontSize: 16, fontWeight: 600, marginBottom: 4 }}>
                    {product.name}
                  </h3>
                  <span style={{ color: '#fbbf24', fontWeight: 700, fontSize: 16, whiteSpace: 'nowrap' }}>
                    ${product.price?.toFixed(2)}
                  </span>
                </div>
                <p style={{
                  color: '#94a3b8', fontSize: 13, lineHeight: 1.5,
                  display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }}>
                  {product.description || 'Sin descripción'}
                </p>
                <div style={{ display: 'flex', gap: 8, marginTop: 8, alignItems: 'center' }}>
                  {product.model_3d_url && (
                    <span style={{
                      background: 'rgba(56, 189, 248, 0.1)',
                      color: '#38bdf8', fontSize: 11, padding: '3px 10px',
                      borderRadius: 20, fontWeight: 600,
                    }}>🥽 AR</span>
                  )}
                  {product.has_modifiers && (
                    <span style={{
                      background: 'rgba(168, 85, 247, 0.1)',
                      color: '#a855f7', fontSize: 11, padding: '3px 10px',
                      borderRadius: 20, fontWeight: 600,
                    }}>⚙️ Personalizable</span>
                  )}
                  <span style={{ color: '#64748b', fontSize: 12 }}>
                    ⏱️ {product.preparation_time_min} min
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedProduct && (
        <ProductModal product={selectedProduct} onClose={() => setSelectedProduct(null)} />
      )}
    </div>
  );
};

export default MenuPage;
